(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["airline-check"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('airline-check')) return;
    const SVG = {
      check: '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M2.5 6.2l2.3 2.3 4.7-5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      cross: '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M3.5 3.5l5 5M8.5 3.5l-5 5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>',
      search: '<svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>',
      plane: '<svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M2 22h20"/><path d="M6.36 17.4 4 17l-2-4 1.1-.55a2 2 0 0 1 1.8 0l.17.1a2 2 0 0 0 1.8 0L8 12 5 6l.9-.45a2 2 0 0 1 2.09.2l4.02 3a2 2 0 0 0 2.1.2l4.19-2.06a2.41 2.41 0 0 1 1.73-.17L21 7a1.4 1.4 0 0 1 .87 1.99l-.38.76c-.23.46-.6.84-1.07 1.08L7.58 17.2a2 2 0 0 1-1.22.18Z"/></svg>',
      chev: '<svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="m9 6 6 6-6 6"/></svg>',
      down: '<svg class="ac-chev" width="16" height="16" viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg>'
    };
    const POPULAR = ['Air France', 'easyJet', 'Ryanair', 'Transavia', 'Vueling', 'Volotea'];
    const fmt = (d) => d.join(' × ') + ' cm';
    const norm = (s) => s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
    const esc = (s) => s.replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    const num = (x) => parseFloat(x.replace(',', '.'));
    const desc = (a) => [...a].sort((x, y) => y - x);

    class AirlineCheck extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        // « 15-20 cm » ou « 15 à 20 cm » (sac extensible) : on retient la plus grande valeur.
        const txt = this.dataset.dims.replace(/(\d+(?:[.,]\d+)?)\s*(?:cm)?\s*(?:-|–|à)\s*(\d+(?:[.,]\d+)?)/g, (m, a, b) => String(Math.max(num(a), num(b))));
        const nums = (txt.match(/\d+(?:[.,]\d+)?/g) || []).map(num).slice(0, 3);
        if (nums.length < 3) return;
        this.bag = desc(nums);
        if (this.bag[0] < 30) return;
        let data = [];
        try { data = JSON.parse(this.querySelector('[data-airlines]').textContent); } catch (e) { return; }
        const fits = (lim) => desc(lim).every((v, i) => this.bag[i] <= v);
        this.rows = data.map(([name, cabin, personal, paid], i) => ({
          i, name, cabin, personal, key: norm(name),
          status: personal && fits(personal) ? 'free' : fits(cabin) ? (paid ? 'paid' : 'cabin') : 'no'
        }));
        this.ok = this.rows.filter((r) => r.status !== 'no');
        if (this.ok.length < parseInt(this.dataset.min || '40', 10)) return;
        this._ready = true;

        this.place = this.dataset.place;
        this.view = this.dataset.view;

        this.dialog = this.querySelector('[data-ac-dialog]');
        this.body = this.dialog.querySelector('[data-ac-body]');
        this.headEl = this.dialog.querySelector('[data-ac-title]');
        this.back = this.dialog.querySelector('[data-ac-back]');
        this.tip = this.dialog.querySelector('[data-ac-tip]');
        this.querySelectorAll('[data-ac-count]').forEach((el) => { el.textContent = this.ok.length; });
        document.body.appendChild(this.dialog); // hors du flux : la fenêtre s'ouvre quel que soit le placement
        this.bindDialog();
        this.mount();
      }

      mount() {
        const scope = this.closest('.product, section') || document;
        const specs = scope.querySelector('.product__key-specs .spec-chips-list');
        const open = () => this.open();
        if (this.place === 'a' && specs) {
          const li = document.createElement('li');
          li.className = 'spec-chip spec-chip--air';
          li.innerHTML = '<button type="button" aria-haspopup="dialog">' + SVG.plane + '<span>' + this.ok.length + ' compagnies</span></button>';
          li.querySelector('button').addEventListener('click', open);
          specs.appendChild(li);
          return;
        }
        if (this.place === 'c' && specs) {
          const chip = specs.querySelector('.spec-chip[title="Dimensions"]');
          if (chip) {
            const btn = document.createElement('button');
            btn.type = 'button';
            btn.setAttribute('aria-haspopup', 'dialog');
            btn.setAttribute('aria-label', 'Dimensions, compatible cabine : vérifier ma compagnie');
            while (chip.firstChild) btn.appendChild(chip.firstChild);
            btn.insertAdjacentHTML('beforeend', '<span class="spec-chip__air"><span class="airline-check__ok">' + SVG.check + '</span>Cabine' + SVG.chev + '</span>');
            btn.addEventListener('click', open);
            chip.classList.add('spec-chip--dims-air');
            chip.appendChild(btn);
            return;
          }
        }
        // Placement b (et repli) : la ligne, juste sous les mesures quand elles existent.
        const wrap = scope.querySelector('.product__key-specs');
        if (wrap && this.place !== 'keep' && this.place !== 'box') wrap.after(this);
        this.hidden = false;
        this.querySelector('[data-ac-open]').addEventListener('click', open);
      }

      bindDialog() {
        const d = this.dialog;
        d.querySelector('[data-ac-close]').addEventListener('click', () => d.close());
        this.back.addEventListener('click', () => this.renderView());
        d.addEventListener('click', (e) => {
          if (e.target === d) return d.close();
          const t = e.target.closest('[data-tarif]');
          if (t) { e.stopPropagation(); return this.showTip(t); }
          if (!e.target.closest('[data-ac-tip]')) this.hideTip();
        });
        d.addEventListener('cancel', (e) => { if (!this.tip.hidden) { e.preventDefault(); this.hideTip(); } });
        d.addEventListener('close', () => this.hideTip());
        this.body.addEventListener('scroll', () => this.hideTip(), { passive: true });
      }

      open() {
        this.renderView();
        this.dialog.showModal();
        const f = this.body.querySelector('input');
        // Au doigt, Safari met le focus (et un cadre) sur la croix : on le place sur la fenêtre.
        if (f && !window.matchMedia('(pointer: coarse)').matches) f.focus();
        else this.dialog.focus({ preventScroll: true });
      }

      renderView() {
        this.hideTip();
        this.back.hidden = true;
        if (this.view === '2') return this.viewCompare();
        if (this.view === '3') return this.viewGroups();
        return this.viewAnswer();
      }

      byName(n) { return this.rows.find((r) => r.name === n); }
      tarif(r) { return '<button type="button" class="ac-tarif" data-tarif="' + r.i + '">Bagage cabine selon votre tarif <span aria-hidden="true">ⓘ</span></button>'; }
      extra(r) { return r.status === 'free' ? '<p class="ac-extra">Passe aussi sous le siège</p>' : r.status === 'paid' ? this.tarif(r) : ''; }
      verdict(r) {
        const ok = r.status !== 'no';
        return '<p class="ac-verdict"><span class="ac-mark' + (ok ? '' : ' ac-mark--no') + '">' + (ok ? SVG.check : SVG.cross) + '</span>' +
          (ok ? 'Oui, il passe en cabine chez ' : 'Trop grand pour la cabine chez ') + esc(r.name) + '</p>';
      }
      allLink() { return '<button type="button" class="ac-all" data-ac-all>Voir les ' + this.ok.length + ' compagnies compatibles</button>'; }
      bindAll() { const b = this.body.querySelector('[data-ac-all]'); if (b) b.addEventListener('click', () => this.viewList()); }

      // 1 · Réponse directe : recherche ou raccourcis, verdict et barres sac / maximum.
      viewAnswer(pick) {
        this.headEl.textContent = 'Et chez votre compagnie ?';
        const sel = pick || this.picked || this.byName('Air France') || this.ok[0];
        this.picked = sel;
        const picks = POPULAR.map((n) => this.byName(n)).filter(Boolean);
        const lim = desc(sel.cabin);
        const labels = ['Longueur', 'Largeur', 'Profondeur'];
        const bars = this.bag.map((b, k) => {
          const over = b > lim[k];
          return '<div><div class="ac-bar__top"><span>' + labels[k] + '</span><span>' + b + ' / ' + lim[k] + ' cm</span></div><div class="ac-bar__track"><div class="ac-bar__fill' + (over ? ' ac-bar__fill--over' : '') + '" style="width:' + Math.min(100, Math.round((b / lim[k]) * 100)) + '%"></div></div></div>';
        }).join('');
        this.body.innerHTML =
          '<div class="ac-field">' + SVG.search + '<input type="search" class="ac-input" placeholder="Rechercher votre compagnie" aria-label="Rechercher votre compagnie" autocomplete="off" data-ac-q></div>' +
          '<ul class="ac-suggest" hidden data-ac-suggest></ul>' +
          '<div class="ac-picks">' + picks.map((r) => '<button type="button" class="ac-pick" aria-pressed="' + (r === sel) + '" data-pick="' + r.i + '">' + esc(r.name) + '</button>').join('') + '</div>' +
          '<div class="ac-result">' + this.verdict(sel) + '<div class="ac-bars">' + bars + '</div>' + this.extra(sel) + '</div>' + this.allLink();
        this.body.querySelectorAll('[data-pick]').forEach((b) => b.addEventListener('click', () => this.viewAnswer(this.rows[b.dataset.pick])));
        const input = this.body.querySelector('[data-ac-q]');
        const sug = this.body.querySelector('[data-ac-suggest]');
        input.addEventListener('input', () => {
          const v = norm(input.value.trim());
          const hits = v ? this.rows.filter((r) => r.key.includes(v)).slice(0, 6) : [];
          sug.innerHTML = hits.map((r) => '<li><button type="button" data-pick="' + r.i + '">' + esc(r.name) + '</button></li>').join('');
          sug.hidden = !hits.length;
          sug.querySelectorAll('[data-pick]').forEach((b) => b.addEventListener('click', () => this.viewAnswer(this.rows[b.dataset.pick])));
        });
        this.bindAll();
      }

      // 2 · Comparateur visuel : gabarit de la compagnie et sac, de face et à l'échelle.
      viewCompare(pick) {
        this.headEl.textContent = 'Votre sac face au gabarit';
        const sel = pick || this.picked || this.byName('Air France') || this.ok[0];
        this.picked = sel;
        const lim = desc(sel.cabin), bag = this.bag;
        const W = 320, H = 210, k = Math.min((H - 20) / Math.max(lim[0], bag[0]), (W * 0.55) / Math.max(lim[1], bag[1]));
        const gw = lim[1] * k, gh = lim[0] * k, bw = bag[1] * k, bh = bag[0] * k;
        const gx = (W - gw) / 2, gy = H - gh - 2, bx = (W - bw) / 2, by = H - bh - 2;
        const ok = sel.status !== 'no';
        const col = ok ? '#2f8a5b' : 'var(--color-signal, #ef7b5e)';
        const svg = '<svg class="ac-figure" viewBox="0 0 ' + W + ' ' + H + '" role="img" aria-label="Sac ' + fmt(bag) + ' comparé au maximum ' + fmt(lim) + '">' +
          '<rect x="' + gx + '" y="' + gy + '" width="' + gw + '" height="' + gh + '" fill="none" stroke="currentColor" stroke-opacity="0.45" stroke-dasharray="5 4"/>' +
          '<rect x="' + bx + '" y="' + by + '" width="' + bw + '" height="' + bh + '" rx="3" fill="' + col + '" fill-opacity="0.14" stroke="' + col + '" stroke-width="1.5"/>' +
          '<text x="' + (W / 2) + '" y="' + (by + bh / 2 + 4) + '" text-anchor="middle" font-size="12" fill="currentColor">' + bag[1] + ' × ' + bag[0] + ' cm</text>' +
          '<text x="' + (gx + gw + 6) + '" y="' + (gy + 12) + '" font-size="11" fill="currentColor" fill-opacity="0.6">' + lim[1] + ' × ' + lim[0] + '</text></svg>';
        const cap = ok
          ? 'Il passe : ' + (lim[0] - bag[0]) + ' cm de marge en hauteur, ' + (lim[1] - bag[1]) + ' cm en largeur, ' + (lim[2] - bag[2]) + ' cm en profondeur.'
          : 'Trop grand : ' + bag.map((b, i) => b > lim[i] ? (b - lim[i]) + ' cm de trop' : '').filter(Boolean).join(', ') + '.';
        this.body.innerHTML =
          '<select class="ac-select" aria-label="Votre compagnie" data-ac-sel>' + this.rows.map((r) => '<option value="' + r.i + '"' + (r === sel ? ' selected' : '') + '>' + esc(r.name) + '</option>').join('') + '</select>' +
          svg + '<div class="ac-legend"><span><i style="border:1px dashed currentColor"></i>Maximum ' + esc(sel.name) + '</span><span><i style="background:' + col + ';opacity:.5"></i>Votre sac</span></div>' +
          '<p class="ac-caption">' + cap + '</p>' + this.extra(sel) + '<br>' + this.allLink();
        this.body.querySelector('[data-ac-sel]').addEventListener('change', (e) => this.viewCompare(this.rows[e.target.value]));
        this.bindAll();
      }

      // 3 · Par catégorie : trois groupes dépliables, recherche qui surligne et ouvre le bon groupe.
      viewGroups() {
        this.headEl.textContent = 'Compagnies compatibles';
        const groups = [
          ['cabin', 'Bagage cabine inclus', ''],
          ['paid', 'Bagage cabine selon votre tarif', 'Inclus dans les tarifs supérieurs, ou à ajouter lors de la réservation.'],
          ['free', 'Passe aussi sous le siège', 'Aucun supplément, même avec le billet le moins cher.']
        ].map(([k, label, info]) => [k, label, info, this.rows.filter((r) => r.status === k)]).filter((g) => g[3].length);
        this.body.innerHTML =
          '<div class="ac-field">' + SVG.search + '<input type="search" class="ac-input" placeholder="Rechercher votre compagnie" aria-label="Rechercher votre compagnie" autocomplete="off" data-ac-q></div>' +
          groups.map(([k, label, info, list], n) => '<details class="ac-group" data-group="' + k + '"' + (n === 0 ? ' open' : '') + '><summary><span class="ac-mark">' + SVG.check + '</span>' + label + '<span class="ac-count">' + list.length + '</span>' + SVG.down + '</summary>' +
            (info ? '<p class="ac-group__info">' + info + '</p>' : '') +
            '<div class="ac-names">' + list.map((r) => '<span class="ac-name" data-key="' + r.key + '">' + esc(r.name) + '</span>').join('') + '</div></details>').join('');
        const input = this.body.querySelector('[data-ac-q]');
        input.addEventListener('input', () => {
          const v = norm(input.value.trim());
          this.body.querySelectorAll('.ac-group').forEach((g) => {
            let hit = false;
            g.querySelectorAll('.ac-name').forEach((n) => { const on = !v || n.dataset.key.includes(v); n.hidden = !on; if (on && v) hit = true; });
            if (v) g.open = hit;
          });
        });
      }

      // Liste complète (depuis les vues 1 et 2).
      viewList() {
        this.headEl.textContent = this.ok.length + ' compagnies compatibles';
        this.back.hidden = false;
        this.body.innerHTML =
          '<div class="ac-field">' + SVG.search + '<input type="search" class="ac-input" placeholder="Rechercher votre compagnie" aria-label="Rechercher votre compagnie" autocomplete="off" data-ac-q></div>' +
          '<ul class="ac-list">' + this.rows.map((r) => {
            const ok = r.status !== 'no';
            return '<li class="ac-row' + (ok ? '' : ' ac-row--no') + '" data-key="' + r.key + '"><span class="ac-mark">' + (ok ? SVG.check : SVG.cross) + '</span><div>' + esc(r.name) +
              (r.status === 'free' ? '<span class="ac-extra">Passe aussi sous le siège</span>' : r.status === 'paid' ? '<button type="button" class="ac-tarif" data-tarif="' + r.i + '">Selon votre tarif <span aria-hidden="true">ⓘ</span></button>' : '') +
              '</div><span class="ac-dims">' + r.cabin.join('×') + ' cm</span></li>';
          }).join('') + '</ul>';
        const input = this.body.querySelector('[data-ac-q]');
        input.addEventListener('input', () => {
          const v = norm(input.value.trim());
          this.body.querySelectorAll('.ac-row').forEach((li) => { li.hidden = !!v && !li.dataset.key.includes(v); });
        });
        this.body.scrollTop = 0;
      }

      showTip(btn) {
        if (!this.tip.hidden && this.tipFor === btn) return this.hideTip();
        const r = this.rows[parseInt(btn.dataset.tarif, 10)];
        this.tipFor = btn;
        this.tip.querySelector('[data-ac-tip-name]').textContent = r.name;
        this.tip.querySelector('[data-ac-tip-personal]').textContent = r.personal ? ' (' + fmt(r.personal) + ' maximum)' : '';
        this.tip.hidden = false;
        const b = btn.getBoundingClientRect();
        const w = this.tip.offsetWidth, h = this.tip.offsetHeight;
        this.tip.style.left = Math.min(Math.max(12, b.left), window.innerWidth - w - 12) + 'px';
        this.tip.style.top = (b.bottom + 8 + h > window.innerHeight - 12 ? b.top - h - 8 : b.bottom + 8) + 'px';
      }
      hideTip() { if (this.tip) { this.tip.hidden = true; this.tipFor = null; } }
    }
    customElements.define('airline-check', AirlineCheck);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bundle-offer"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('bundle-offer')) return;
    class BundleOffer extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        this.price = parseInt(this.dataset.price, 10);
        this.tiers = [...this.querySelectorAll('[data-tier]')];
        this.slots = [...this.querySelectorAll('[data-slot]')];
        this.gifts = [...this.querySelectorAll('[data-gift]')];
        this.panel = this.querySelector('[data-panel]');
        this.form = document.getElementById(this.dataset.form);
        this.tier = 1;
        this.inside = ['stack', 'compact', 'line', 'inline', 'boxed', 'gifts', 'reveal', 'band', 'progressive'].includes(this.dataset.style);
        this.offer = ['gifts', 'reveal', 'band'].includes(this.dataset.style);
        if (this.offer && this.giftsWrapEl()) { const sl = this.querySelector('[data-slots]'); if (sl) this.giftsWrapEl().after(sl); }
        this.list = ['line', 'inline', 'boxed', 'progressive'].includes(this.dataset.style);
        this.prog = this.dataset.style === 'progressive';
        this.giftsWrap = this.querySelector('.bo__gifts-wrap');
        if (this.list && this.giftsWrap) this.querySelector('.bo__tiers').after(this.giftsWrap);
        this.tiers.forEach((t) => {
          const n = parseInt(t.dataset.tier, 10);
          const c = this.gifts.filter((g) => parseInt(g.dataset.min, 10) <= n).length;
          const el = t.querySelector('[data-giftcount]');
          if (el && c) el.textContent = (this.offer || this.prog) ? c + ' produit' + (c > 1 ? 's' : '') + ' offert' + (c > 1 ? 's' : '') : '+ ' + c + ' cadeau' + (c > 1 ? 'x' : '');
          if (this.prog && el) { t.querySelector('.bo__info').appendChild(el); const off = t.querySelector('.bo__off'); if (off) t.querySelector('.bo__label').appendChild(off); }
          if (this.offer && el && c) { const lab = t.querySelector('.bo__label'); const sep = document.createElement('span'); sep.className = 'bo__sep'; sep.setAttribute('aria-hidden', 'true'); lab.after(sep); sep.after(el); }
          // Vignettes des cadeaux de la formule (présentation « liste »)
          const av = document.createElement('span');
          av.className = 'bo__avatars';
          this.gifts.filter((g) => parseInt(g.dataset.min, 10) <= n).slice(0, 3).forEach((g) => {
            const img = g.querySelector('img');
            if (img) { const c2 = img.cloneNode(); c2.alt = ''; c2.loading = 'eager'; av.appendChild(c2); }
          });
          if (this.offer && av.childElementCount) { av.classList.add('bo__thumbs'); t.querySelector('.bo__info').after(av); av.title = ''; }
          else if (av.childElementCount) { av.title = 'Offert : ' + this.gifts.filter((g) => parseInt(g.dataset.min, 10) <= n).map((g) => g.querySelector('.bo__gift-name').textContent.trim()).join(', '); t.querySelector('.bo__prices').before(av); }
          if (this.list && !this.prog) { const bd = t.querySelector('.bo__badge'); if (bd) t.querySelector('.bo__info').appendChild(bd); const off = t.querySelector('.bo__off'); if (off) t.querySelector('.bo__label').after(off); }
          t.addEventListener('click', (e) => { if (!e.target.closest('[data-panel]')) this.select(n); });
          t.addEventListener('keydown', (e) => this.keys(e, n));
        });
        this.slots.forEach((s) => s.addEventListener('click', (e) => {
          const b = e.target.closest('[data-variant]');
          if (!b) return;
          s.querySelectorAll('[data-variant]').forEach((x) => x.setAttribute('aria-checked', String(x === b)));
          s.querySelector('[data-slot-name]').textContent = b.title;
        }));
        const scope = this.closest('.product, section') || document;
        document.addEventListener('variant:change', (e) => {
          const v = e.detail && e.detail.variant;
          if (!v || !scope.contains(e.target)) return;
          this.price = v.price;
          this.render();
        });
        if (this.form) {
          this.form.addEventListener('formdata', (e) => this.fill(e.formData));
          this.addPrice = this.form.querySelector('.buy-buttons__price');
        }
        this.render();
      }
      giftsWrapEl() { return this.querySelector('.bo__gifts-wrap'); }
      keys(e, n) {
        const list = this.tiers.map((t) => parseInt(t.dataset.tier, 10));
        const i = list.indexOf(n);
        if (['ArrowRight', 'ArrowDown'].includes(e.key)) { e.preventDefault(); this.select(list[(i + 1) % list.length], true); }
        if ((e.key === 'Enter' || e.key === ' ') && e.target === e.currentTarget) { e.preventDefault(); this.select(n); }
        if (['ArrowLeft', 'ArrowUp'].includes(e.key)) { e.preventDefault(); this.select(list[(i - 1 + list.length) % list.length], true); }
      }
      money(cents) {
        const v = (Math.round(cents) / 100).toFixed(2);
        const fmt = this.dataset.money || '€{{amount_with_comma_separator}}';
        return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => (k.includes('comma') ? v.replace('.', ',') : v));
      }
      calc(t) {
        const q = parseInt(t.dataset.qty, 10), d = parseInt(t.dataset.discount, 10) || 0;
        const full = this.price * q, total = Math.round(full * (100 - d) / 100);
        return { q, d, full, total, each: Math.round(total / q), save: full - total };
      }
      select(n, focus) {
        this.flash = this.tier !== n || this.offer;
        this.tier = n;
        this.render();
        if (focus) this.tiers.find((t) => t.dataset.tier == n).focus();
      }
      render() {
        let cur;
        this.tiers.forEach((t) => {
          const on = parseInt(t.dataset.tier, 10) === this.tier;
          t.setAttribute('aria-checked', String(on));
          t.tabIndex = on ? 0 : -1;
          const c = this.calc(t);
          const set = (sel, val) => { const el = t.querySelector(sel); if (el) el.textContent = this.money(val); };
          set('[data-total]', c.total); set('[data-compare]', c.full); set('[data-each]', c.each); set('[data-save]', c.save);
          if (this.prog) {
            const n = parseInt(t.dataset.tier, 10);
            const g = this.gifts.filter((x) => parseInt(x.dataset.min, 10) <= n).length;
            const gc = t.querySelector('[data-giftcount]');
            const gifts = g ? g + ' produit' + (g > 1 ? 's' : '') + ' offert' + (g > 1 ? 's' : '') : '';
            if (gc) gc.textContent = c.q > 1 ? 'soit ' + this.money(c.each) + ' le sac' + (gifts ? ' + ' + gifts : '') : gifts;
          }
          if (on) cur = { t, ...c };
        });
        this.slots.forEach((s) => { s.hidden = parseInt(s.dataset.slot, 10) > cur.q; });
        let unlocked = 0, k = 0;
        this.gifts.forEach((g) => {
          const lock = parseInt(g.dataset.min, 10) > this.tier;
          const was = g.classList.contains('is-locked');
          g.classList.toggle('is-locked', lock);
          if (!lock) {
            unlocked++;
            if (this.offer && this.flash && this._painted) { g.style.setProperty('--i', k++); g.classList.remove('is-flash'); void g.offsetWidth; g.classList.add('is-flash'); }
            else if (was && this._painted) { g.style.setProperty('--i', k++); g.classList.remove('is-new'); void g.offsetWidth; g.classList.add('is-new'); }
          }
        });
        this._painted = true;
        this.flash = false;
        const title = this.querySelector('[data-gifts-title]');
        const total = this.gifts.length;
        if (this.prog) {
          const value = this.gifts.filter((g) => !g.classList.contains('is-locked')).reduce((a, g) => a + (parseInt(g.dataset.price, 10) || 0), 0);
          const was = this.querySelector('[data-gift-was]'), now = this.querySelector('[data-gift-now]');
          if (was) was.textContent = value ? this.money(value) : '';
          if (now) now.textContent = this.money(0);
        }
        if (this.offer && title && this.dataset.style !== 'band') { title.hidden = true; }
        const titles = { progressive: '', gifts: '', reveal: '', band: unlocked ? 'Offert avec cette formule' : '', segment: 'Cadeaux offerts selon la formule', line: 'Offert :', inline: 'Vos cadeaux', boxed: 'Vos cadeaux · ' + unlocked + ' sur ' + total };
        if (title) title.textContent = titles[this.dataset.style] || (unlocked ? 'Offert avec cette formule' : '');
        if (title && !(this.offer && this.dataset.style !== 'band')) title.hidden = !title.textContent;
        const tot = this.querySelector('[data-sum-total]'), line = this.querySelector('[data-sum-line]');
        if (tot) tot.textContent = this.money(cur.total);
        if (line) line.innerHTML = cur.q > 1 ? 'soit ' + this.money(cur.each) + ' le sac · <strong>économie ' + this.money(cur.save) + '</strong>' : (unlocked ? unlocked + ' cadeau' + (unlocked > 1 ? 'x' : '') + ' offert' + (unlocked > 1 ? 's' : '') : '');
        if (this.inside && this.panel && this.panel.parentElement !== cur.t) cur.t.appendChild(this.panel);
        if (this.addPrice) this.addPrice.textContent = '· ' + this.money(cur.total);
      }
      // À l'envoi du formulaire : un article par couleur choisie + les cadeaux débloqués.
      fill(fd) {
        const c = this.calc(this.tiers.find((t) => parseInt(t.dataset.tier, 10) === this.tier));
        const unlocked = this.gifts.filter((g) => !g.classList.contains('is-locked'));
        if (c.q === 1 && !unlocked.length) return;
        const main = fd.get('id');
        const counts = new Map([[main, 1]]);
        this.slots.filter((s) => !s.hidden).forEach((s) => {
          const b = s.querySelector('[aria-checked="true"]');
          const id = b ? b.dataset.variant : main;
          counts.set(id, (counts.get(id) || 0) + 1);
        });
        fd.delete('id'); fd.delete('quantity');
        let i = 0;
        const label = this.tiers.find((t) => parseInt(t.dataset.tier, 10) === this.tier).querySelector('.bo__label').dataset.name;
        counts.forEach((q, id) => {
          fd.append('items[' + i + '][id]', id); fd.append('items[' + i + '][quantity]', q);
          if (c.q > 1) fd.append('items[' + i + '][properties][_Formule]', label);
          i++;
        });
        unlocked.forEach((g) => {
          fd.append('items[' + i + '][id]', g.dataset.gift); fd.append('items[' + i + '][quantity]', 1);
          fd.append('items[' + i + '][properties][Cadeau]', 'Offert'); i++;
        });
      }
    }
    customElements.define('bundle-offer', BundleOffer);
  })();
  } catch(e) { console.error(e); }
})();

})();
